import { cognitoRedirectUri } from '../../../../config';

const Login = () => {
    window.location.href = `${process.env.REACT_APP_COGNITO_DOMAIN}&redirect_uri=${cognitoRedirectUri}`;
    return null;
};

export default Login;
